export default class EventBus {
    private bus: any;

    /**
     * Initialize a new event bus instance.
     */
    constructor() {
        this.bus = document.createElement('fakeElement');
    }

    /**
     * Add an event listener.
     */
    on(event:string, callback:(event: any) => void, vueInstance:any = null) {
        let callbackInstance:any = (e:any) => callback.apply(vueInstance, [e.detail]);
        this.bus.addEventListener(event, callbackInstance);
        if (vueInstance && vueInstance.$options) {
            if (Array.isArray(vueInstance.$options.beforeDestroy)) {
                vueInstance.$options.beforeDestroy.push(() => {
                    callbackInstance && this.off(event, callbackInstance);
                });
            }
            if (vueInstance.$options.beforeDestroy === undefined) {
                vueInstance.$options.beforeDestroy = [() => {
                    callbackInstance && this.off(event, callbackInstance);
                }]
            }
        }
    }

    /**
     * Remove an event listener.
     */
    off(event:string, callback:any) {
        this.bus.removeEventListener(event, callback);
    }

    /**
     * Dispatch an event.
     */
    emit(event:string, detail = {}) {
        this.bus.dispatchEvent(new CustomEvent(event, {detail}));
    }
}